// extracted by mini-css-extract-plugin
export var modal = "_vk-0";
export var table = "_vk-1";